import React, { useEffect, useState } from "react";
import { Layout as AntdLayout } from "antd";
import { inject } from "mobx-react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Content from "./Content";
import { IAppStore } from "../stores/Interfaces";
import { getToken } from "../helpers/auth";

interface Props {
  children?: React.ReactNode;
  store?: IAppStore;
}

const Layout: React.FC<Props> = ({ children, store }) => {
  const location = useLocation();

  const [previousPath, setPreviousPath] = useState<string | null>(null);

  useEffect(() => {
    const pathName = location.pathname;

    if (previousPath !== pathName) {
      store?.settingsStore.resetScrollPosition();
      setPreviousPath(pathName);
    }
  }, [location.pathname, previousPath, store]);

  if (!getToken()) {
    return <>{children}</>;
  }

  return (
    <AntdLayout>
      <Header />
      <Content>{children}</Content>
    </AntdLayout>
  );
};

export default inject("store")(Layout);
